// extracted by mini-css-extract-plugin
export var productImage = "_p0-1";
export var viewLink = "_p0-2";
export var wishlistItem = "_p0-0";